export default "__VITE_ASSET__Cdw23iM9__"